import { FormattedMessage } from 'react-intl';

import AccessDeniedIcon from '@/assets/icons/access-denied.svg';

import { Typography } from './typography';

export function AccessDenied() {
  return (
    <div className="mx-auto flex min-h-screen w-[300px] flex-col items-center justify-center">
      <img src={AccessDeniedIcon} alt="" />
      <Typography variant="body2">
        <FormattedMessage
          defaultMessage="Access denied"
          description="Full-page 403: short title above explanation"
        />
      </Typography>
      <Typography variant="subtitle1" className="text-center">
        <FormattedMessage
          defaultMessage="You don’t have permission to access this page. If you believe this is an error, please contact your administrator or manager."
          description="Body copy for 403: contact admin for Source role issues"
        />
      </Typography>
    </div>
  );
}
